import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MissionUser')
export class MissionUser {

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('mission_progress_quantity', Number)
  missionProgressQuantity: number = 0;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;
}
